import React from "react";
import { useCart } from "../../../contexts/CartContext";

const BudgetProgressBar = ({ budget }) => {
  const { cart } = useCart();

  // Calculer le total des produits/services dans le panier
  const totalCartValue = cart.reduce(
    (total, item) => total + item.price * item.quantity,
    0
  );

  // Éviter les erreurs si le budget est 0 ou indéfini
  const safeBudget = budget || 0;

  // Calculer le pourcentage de budget utilisé
  const progressPercentage =
    safeBudget > 0 ? Math.min((totalCartValue / safeBudget) * 100, 100) : 0;

  // Déterminer la couleur de la barre en fonction du pourcentage
  const progressColor =
    progressPercentage <= 75
      ? "bg-green-500"
      : progressPercentage <= 85
      ? "bg-yellow-500"
      : "bg-red-500";

  return (
    <div className="w-full mt-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">
          Budget utilisé
        </span>
        <span className="text-sm font-medium text-gray-700">
          ${totalCartValue.toFixed(2)} / ${safeBudget.toFixed(2)}
        </span>
      </div>
      {/* Conteneur de la progress bar */}
      <div className="w-full h-4 bg-gray-200 rounded-lg overflow-hidden">
        <div
          className={`h-full ${progressColor}`}
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      {/* Indicateur de dépassement */}
      {progressPercentage > 100 && (
        <p className="text-sm text-red-500 mt-2">
          Vous avez dépassé votre budget !
        </p>
      )}
    </div>
  );
};

export default BudgetProgressBar;
